import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logoImg from '../assets/logo_horizontal.png';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    { path: '/', label: 'Dashboard' },
    { path: '/aprovacao-musicas', label: 'Musicas' },
    { path: '/atualizacao-perfis', label: 'Perfis' },
    { path: '/validacoes-pendentes', label: 'Validacoes' },
    { path: '/tribos-pendentes', label: 'Tribos pendentes' },
    { path: '/tribos-ativas', label: 'Tribos ativas' },
    { path: '/denuncias', label: 'Denuncias' },
    { path: '/mensagens-ajuda', label: 'Ajuda' },
    { path: '/estatisticas', label: 'Analytics' },
    { path: '/play-analytics', label: 'Top 50' },
    { path: '/publicacoes-sociais', label: 'Redes sociais' },
  ];

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div style={styles.headerLeft} onClick={() => navigate('/')}>
          <img src={logoImg} alt="Tribhus" style={styles.logo} />
          <span style={styles.badge}>ADMIN</span>
        </div>

        <nav style={styles.nav}>
          {menuItems.map((item) => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              style={{
                ...styles.navItem,
                ...(location.pathname === item.path ? styles.navItemActive : {}),
              }}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div style={styles.headerRight}>
          <span style={styles.adminName}>{admin?.nome}</span>
          <button onClick={handleLogout} style={styles.logoutButton}>
            Sair
          </button>
        </div>
      </header>

      <main style={styles.main}>
        {children}
      </main>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#121212',
  },
  header: {
    background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
    padding: '12px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
    borderBottom: '1px solid rgba(255, 102, 0, 0.2)',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    cursor: 'pointer',
  },
  logo: {
    height: '40px',
    width: 'auto',
  },
  badge: {
    backgroundColor: '#ff6600',
    color: '#fff',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '10px',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  nav: {
    display: 'flex',
    gap: '5px',
  },
  navItem: {
    background: 'transparent',
    border: 'none',
    color: '#b0b0b0',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '500',
    transition: 'all 0.3s ease',
  },
  navItemActive: {
    backgroundColor: 'rgba(255, 102, 0, 0.15)',
    color: '#ff6600',
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  adminName: {
    color: '#b0b0b0',
    fontSize: '14px',
  },
  logoutButton: {
    background: 'transparent',
    border: '1px solid #ff6600',
    color: '#ff6600',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '500',
    transition: 'all 0.3s ease',
  },
  main: {
    padding: '24px',
    maxWidth: '1400px',
    margin: '0 auto',
  },
};

export default Layout;
